<template>
    <el-dialog :width="config.dialogWidth ? config.dialogWidth : '800px'"
        v-dialogDrag
        :visible.sync="dialogVisible"
        :append-to-body="true"
        @close="dialogClose"
        :close-on-click-modal="config.CloseOnClickModal || false"
        :close-on-press-escape="config.CloseOnPressEscape || false">
        <template v-slot:title>
            <div class="column-config_title">
                {{dialogTitle}}
            </div>
        </template>
        <div class="otp-advance-dialog-container">
            <div class="top-search-group" v-show="!disableSearch">
                <el-form :inline="true" :model="searchObj">
                    <el-form-item>
                        <el-select v-model="searchObj.key" placeholder="请选择">
                            <el-option v-for="option in selectOptions"
                                :key="option.prop"
                                :label="option.value"
                                :value="option.prop"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model.trim="searchObj.keyword" placeholder="请输入" @keyup.enter.native="search" @change="inputChange"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button @click="reset">重置</el-button>
                    </el-form-item>
                    </el-form>
            </div>
            <el-row :gutter="20">
                <el-col :span="multiple?16:24">
                    <el-table
                        ref="listTable"
                        :data="tableData"
                        highlight-current-row
                        v-loading="loading"
                        height="300"
                        :row-class-name="tableRowClassName"
                        :border="config.border ? config.border : false"
                        @current-change="currentRowChange"
                        @row-dblclick="rowDbClick"
                        @row-click="selectionRow"
                        @select="changeSelect"
                        @select-all="changeSelectAll">
                        <el-table-column v-if="config.multiple" type="selection" width="55"></el-table-column>
                        <el-table-column
                            v-for="(column, index) in config.tableConfig"
                            :key="column.prop + index"
                            :prop="column.prop"
                            :label="column.value"
                            :width="column.width"
                            :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <template v-if="column.type === 'select'">{{dictFormat(row[column.prop], column.optionsKey,column.options) }}</template>
                                <template v-else>{{row[column.prop]}}</template>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col :span="8" v-if="multiple">
                    <el-table :data="advanceList" class="table-box" height="300" highlight-current-row>
                        <template v-if="config.multipleTableConfig && config.multipleTableConfig.length">
                            <el-table-column
                            v-for="(column, index) in config.multipleTableConfig"
                            :key="column.prop + index"
                            :prop="column.prop"
                            :label="column.value"
                            :width="column.width"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        </template>
                        <el-table-column v-else :prop="config.multipleTableColumn.prop" :label="config.multipleTableColumn.value"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="60">
                            <template v-slot="scope">
                                <el-button class="deleteBtn" @click="deleteDate(scope.$index, scope.row)" size="small" type='text'>删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div class="config-footer">
                <el-row>
                    <el-col v-if="mode !== 'EbPlace' && !config.noPagination" :span="3" style="line-height:30px;">共&nbsp;&nbsp;{{pageTotal}}&nbsp;&nbsp;项</el-col>
                    <el-col v-if="mode !== 'EbPlace' && !config.noPagination" :span="16">
                        <el-pagination
                            v-if="!config.noPagination"
                            background
                            class="table-pagination"
                            layout="prev, pager, next"
                            :current-page.sync="page.pageNo"
                            :page-size="page.pageSize"
                            :total="pageTotal"
                            @current-change="currentChange">
                        </el-pagination>
                    </el-col>
                    <el-col :offset="mode === 'EbPlace' || config.noPagination ? 19 : 0" :span="5" style="text-align: right;">
                        <el-button type="text" @click="dialogVisible = false;">取消</el-button>
                        <el-button type="primary" @click="confirm" :disabled="disabledCancel">确定</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import request from '@/utils/http';
import { dictWithUrl } from '../api';
import { getCompareKeys } from '../../otpPanel/advanceUtil';
export default {
    name: 'otpAdvanceDialogForSearch',
    props: {
        maxSelect: { // 最多可选数
            type: Number,
            default: 0
        },
        disabledDbClick: {
            type: Boolean,
            default: false
        },
        rejectClose: {
            type: Boolean,
            default: false
        },
        disableSearch: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['currentTenant']),
        selectOptions() {
            return this.config.advanceConfig || this.config.tableConfig;
        },
        dialogTitle() {
            return this.config.advanceLabel || this.config.name || this.config.label;
        },
        maxSelectNumber() {
            return this.maxSelect || this.maxSelectNum;
        }
    },
    data() {
        return {
            maxSelectTip: null,
            disabledCancel: false,
            dialogVisible: false,
            requestMethod: 'get',
            loading: false,
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            searchObj: {},
            tableData: [],
            config: {},
            multiple: false,
            advanceList: [],
            mode: '',
            optionsData: [],
            maxSelectNum: 0
        };
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                this.disabledCancel = false;
            }
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let params = {};
            // 对关键字的[]{}符号进行转义
            const keyword = this.requestMethod === 'get' ? this.searchObj.keyword.replace(/{/g, '%7b').replace(/}/g, '%7d').replace(/\[/g, '%5b').replace(/\]/g, '%5d') : this.searchObj.keyword;
            if (this.searchObj.key === 'ALL') {
                params = { ...this.advanceCascade, ...this.page };
                for (let i = 1; i < this.selectOptions.length; i++) {
                    params[this.selectOptions[i].prop] = keyword;
                }
            } else if (this.paramType) {
                params = { ...this.page, param: { ...this.advanceCascade, [this.searchObj.key]: keyword } };
            } else {
                params = { ...this.advanceCascade, ...this.page, [this.searchObj.key]: keyword };
            }
            const reqConfig = {
                method: this.requestMethod,
                url: `${this.prefix}${this.config.advanceUrl}`
            };
            if (this.requestMethod === 'get') {
                reqConfig.params = params;
            } else {
                reqConfig.data = params;
            }
            if (this.hasTenant) {
                reqConfig.headers = { ...reqConfig.headers, tenantCode: this.currentTenant.tenantCode };
            }
            if (this.config.queryConditionRequired && !this.searchObj.keyword) {
                this.$message.warning('查询条件不能为空!');
                this.loading = false;
                return false;
            }
            const res = await request(reqConfig);
            if (res && res.code === '0') {
                if (res.data.totalPage !== 0 && this.page.pageNo > res.data.totalPage) {
                    this.page.pageNo = res.data.totalPage;
                    this.fetchData();
                } else {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
                if (this.mode === 'EbPlace') { // 处理地区选择时的格式情况
                    this.tableData = res.data;
                }
            } else {
                this.tableData = [];
            }
            if (this.config.multiple) {
                this.tableSelect();
            }
            this.loading = false;
        },
        show(status = true, config, advanceCascade = {}, mode = '', cache = [], keywords) {
            this.requestMethod = config.method || 'get';
            this.prefix = config.prefix || '/api-mdm/';
            this.hasTenant = config.hasTenant || false;
            this.dialogVisible = status;
            this.paramType = config.paramType || false;
            this.multiple = config.multiple ? config.multiple : false;
            this.maxSelectNum = config.maxSelect || 0;
            if (status === false) return;
            if (!config) {
                this.$message.error('弹窗配置对象为空！');
                return;
            }
            if (this.multiple) {
                this.advanceList = [...cache];
                this.currentRow = cache;
            }
            this.mode = mode;
            this.config = config;
            let initkey = null;
            this.config.cbParams.forEach(itemA => {
                let { 0: sourceProp, 1: destProp } = itemA.split('#');
                destProp = destProp || sourceProp;
                this.selectOptions.forEach(itemB => {
                    if (itemB.prop === sourceProp && this.config.value === destProp) {
                        initkey = itemB.prop; // 下拉框有多个选择匹配选项
                    }
                });
            });
            this.$set(this.searchObj, 'key', (!this.config.advanceNotSearch && this.config.advanceReadonly && initkey) ? initkey : this.selectOptions[0].prop);
            this.$set(this.searchObj, 'keyword', keywords || '');
            this.advanceCascade = advanceCascade;
            this.config.advanceNotSearch || this.fetchData();
            const selectKeyCols = _.chain(this.config.tableConfig).filter(obj => obj.optionsKey).value();
            selectKeyCols.forEach(item => {
                if (item.optionsKey) {
                    dictWithUrl(item.optionsKey, item.dictUrl).then(res => {
                        this.$set(item, 'options', res.data[item.optionsKey] || {});
                    });
                }
            });
        },
        dictFormat(val, optionsKey, options) {

            if (options) {
                return _.get(options, val, val);
            } else {
                return val;
            }
        },
        // 行样式
        tableRowClassName ({ row }) {
            if (row.used) {
                return 'grey-row';
            }
        },
        // 页码变化
        currentChange(val) {
            this.page.pageNo = val;
            this.fetchData();
        },
        // 搜索
        search() {
            this.page.pageNo = 1;
            this.fetchData();
        },
        // 重置
        reset() {
            this.searchObj.keyword = '';
            this.advanceList = [];
            this.config.advanceNotSearch || this.fetchData();
        },
        // 表格
        currentRowChange(row) {
            if (row && !row.used) {
                this.currentRow = row;
            }
        },
        // 表格双击
        rowDbClick(row) {
            if (this.disabledDbClick) return false;
            if (row.used) return false;
            this._emitResult(row);
        },
        confirm() {
            if (!this.currentRow) {
                this.$message.warning('没选中数据');
                return;
            }
            this._emitResult(this.currentRow);
        },
        // 返回选中值
        _emitResult(row) {
            const data = {};
            if (!this.config.cbParams) {
                this.$message.error('弹窗没定义cbParams配置!');
                return;
            }
            const cloned = _.cloneDeep(this.advanceList || []);
            if (this.multiple) {
                let searchData = {};
                this.config.tableConfig.forEach(item => {
                    searchData[item.prop] = [];
                    this.advanceList.map(aitem => {
                        searchData[item.prop].push(aitem[item.prop]);
                    });
                    row[item.prop] = searchData[item.prop].join(',');
                });
            }
            for (const item of this.config.cbParams) {
                let { 0: sourceProp, 1: destProp } = item.split('#');
                destProp = destProp || sourceProp;
                data[destProp] = row[sourceProp];
            }
            this.$emit('confirm', data, this.config, [].concat(cloned));
            if (this.rejectClose) {
                this.disabledCancel = true;
                return false;
            }
            this.dialogVisible = false;
        },
        inputChange(val) { },
        dialogClose() {
            // 重置属性
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.pageTotal = 0;
            this.searchObj = {};
            this.tableData = [];
            this.$emit('close');
        },
        // 对table中的checkbox进行选中/未选中切换
        toggleRowSelection(...args) {
            this.$nextTick(() => {
                if (this.$refs.listTable) {
                    this.$refs.listTable.toggleRowSelection(...args);
                }
            });
        },
        deleteDate(index, row) {
            this.advanceList.splice(index, 1);
            this.judgeEqual(this.tableData, row, (cItem, cIndex) => {
                this.toggleRowSelection(cItem, false);
            });
        },
        selectionRow(currentRow) {
            if (this.multiple) {
                if (this.judgeEqual(this.advanceList, currentRow)) {
                    this.toggleRowSelection(currentRow, true); // 已在选中列表中：将checkbox选中
                    return;
                }
                if (!this.validateMaxNum([currentRow])) return;
                let num = 0;
                this.advanceList.map(item => {
                    if (item[this.config.tableConfig[0].prop] === currentRow[this.config.tableConfig[0].prop] &&
                    item[this.config.tableConfig[1].prop] === currentRow[this.config.tableConfig[1].prop]) {
                        num += 1;
                    }
                });
                if (num === 0) {
                    this.advanceList.push(currentRow);
                    this.toggleRowSelection(currentRow, true);
                }
            } else {
                this.advanceList = currentRow;
            }
        },
        /**
         * @description: 判断对象theItem是否存在于数组array中
         * @param {array} array 需要操作比较的数组
         * @param {object} theItem 需要比较的单个数据项对象
         * @param {function} callback 判断完成后的回调函数
         * @returns boolean
         */
         judgeEqual(array, theItem, callback) {
            const index = array.findIndex(row => {
                const keys = getCompareKeys(this.config); // 优先使用配置的比较keys
                if (keys.length === 0) {
                    // 没有配置，则使用两个对象的公共字段
                    const shareKeys = Object.keys(row).filter(key => {
                        return Object.keys(theItem).includes(key);
                    });
                    keys.push(...shareKeys);
                }
                // 所有key都相等才为true
                return keys.every(key => _.isEqual(row[key], theItem[key]));
            });

            if (index >= 0 && _.isFunction(callback)) {
                callback(array[index], index);
            }
            return index >= 0;
        },
        /**
         * @description: 对表格进行选择操作
         */
        tableSelect() {
            this.tableData.forEach((item) => {
                this.judgeEqual(this.advanceList, item, () => {
                    this.toggleRowSelection(item, true);
                });
            });
        },
        /**
         * @description: 单选操作
         * @param {array} data 当前选中的数据数组
         * @param {object} row 当前操作行对象
         */
        changeSelect(data, row) {
            if (!this.config.multiple) return;
            const inOrDel = data.indexOf(row);
            if (inOrDel < 0) {
                this.judgeEqual(this.advanceList, row, (cItem, cIndex) => {
                    this.deleteDate(cIndex, cItem);
                });
            } else {
                const isHaved = this.judgeEqual(this.advanceList, row);
                if (!isHaved) {
                    if (this.validateMaxNum([row])) {
                        this.advanceList.push(row);
                    } else {
                        // 将checkbox置空
                        this.toggleRowSelection(row, false);
                    }
                }
            }
        },
        /**
         * @description: 全选操作
         * @param {array} data 当前选中的数据数组
         */
        changeSelectAll(data) {
            if (data.length > 0) {
                // 过滤掉已选项，得到新选择的项
                const addes = data.filter(item => !this.judgeEqual(this.advanceList, item));
                if (this.validateMaxNum(addes)) {
                    addes.forEach((item) => this.changeSelect(addes, item));
                } else {
                    // 不可添加，将对应行checkbox置空
                    addes.forEach(item => this.toggleRowSelection(item, false));
                }
            } else {
                this.tableData.forEach((item) => {
                    this.judgeEqual(this.advanceList, item, (cItem, cIndex) => {
                        this.deleteDate(cIndex, cItem);
                    });
                });
            }
        },
        /**
         * 判断是否会超出最大可选项
         * @param {object[]} addes 新添加的项
         * @param {boolean} silent 是否显示提示信息
         * @returns boolean
         */
        validateMaxNum(addes, silent) {
            const total = [].concat(addes, this.advanceList);
            if (this.maxSelectNumber > 0 && total.length > this.maxSelectNumber) {
                if (!silent) {
                    this.maxSelectTip && this.maxSelectTip.close();
                    this.maxSelectTip = this.$message.warning(`最多可选 ${this.maxSelectNumber} 项!`);
                }
                return false;
            }
            return true;
        }
    }
};

</script>

<style lang="less">
.column-config_title{
    small{
        margin-left: 25px;
    }
}
.otp-advance-dialog-container {
    .config-footer {
        margin-top: 18px;
    }
    .table-pagination{
        float: right;
        padding: 0;
        .el-pager li.active + li {
            border-left: 1px solid #cccccc;
        }
        .el-pager li:not(.disabled).active{
            border: 1px solid #00BCBF;
        }
    }
    .el-pagination.is-background{
        .btn-prev, .btn-next, .el-pager li{
            background-color: #ffffff;
            border: 1px solid #cccccc;
            border-radius: 4px;
        }
    }
    .el-table__body tr.grey-row>td {
            background: rgb(214, 214, 212);
        }
}
</style>
